var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyle from '../StyledComponents/GlobalStyle';
import { has, mergeDeepRight, mergeDeepLeft, pipe, assocPath } from 'ramda';
import baseTheme from '../../themes/baseTheme';
import * as themes from '../../themes';
import getIcons from '../iconFactory';
import setFavicon from './favicon';
import Helmet from 'react-helmet';
var Wrapper = styled.div(_templateObject, function (props) {
  return props.bgColor ? props.bgColor : 'transparent';
});

var getThemeModule = function getThemeModule(themeId) {
  if (has(themeId, themes)) {
    return themes[themeId];
  }

  return themes['simply'];
};

export var getThemeConfig = function getThemeConfig(themeId) {
  return mergeDeepRight(baseTheme, getThemeModule(themeId) || {});
};
export var resolveTheme = function resolveTheme(options) {
  var themeId = options.client ? options.client : 'simply';
  var configuredTheme = pipe(getThemeConfig, function (t) {
    return {
      theme: t
    };
  }, assocPath(['theme', 'wrapAssetPath'], options.wrapAssetPaths === false ? false : true), assocPath(['theme', 'unSlashAssetUrlsInCss'], options.unSlashAssetUrlsInCss === false ? false : true))(themeId);
  var icons = getIcons(configuredTheme); // has the form {:icons {} :iconsForCssUrls {}}

  return mergeDeepLeft(configuredTheme, {
    theme: icons
  });
};

var Theme = function (_Component) {
  _inherits(Theme, _Component);

  function Theme() {
    _classCallCheck(this, Theme);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Theme.prototype.render = function render() {
    var importedTheme = resolveTheme(this.props);

    if (this.props.shouldSetFavicon !== false) {
      setFavicon(importedTheme.theme);
    }

    return React.createElement(Fragment, null, React.createElement(Helmet, null, importedTheme.theme.google_font && React.createElement('link', {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com'
    }), importedTheme.theme.google_font && React.createElement('link', {
      href: 'https://fonts.googleapis.com/css2?family=' + importedTheme.theme.google_font + '&display=swap',
      rel: 'stylesheet'
    })), React.createElement(ThemeProvider, importedTheme, React.createElement(Fragment, null, React.createElement(GlobalStyle, {
      withoutMargin: this.props.withoutMargin
    }), React.createElement(Wrapper, {
      bgColor: importedTheme.theme.ui && importedTheme.theme.ui.bodyWrapperBgColor
    }, this.props.children))));
  };

  return Theme;
}(Component);

export default Theme; // TODO: cater for this in Astro3

export var DEFAULT_INPUT_FONT_WEIGHT = 500;
export var DEFAULT_BORDER_COLOR = '#D1D6DA';
export var borderColor = function borderColor(props) {
  return props.theme.border_colour || DEFAULT_BORDER_COLOR;
};
export var inputWeight = function inputWeight(props) {
  return props.theme.font && props.theme.font.input_weight || DEFAULT_INPUT_FONT_WEIGHT;
};